<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="发票名称/税号">
          <el-input placeholder="请输入发票名称/税号" v-model="formInline.search_name">
          
          </el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select size="small" v-model="formInline.status" placeholder="不限制">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未审核" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
            <el-option label="未通过" :value="3"></el-option>
            <el-option label="请重新审核" :value="4"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="reast">重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="success" @click="onExport" >导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    
<!-- 
    <div class="common-level-rail"> 
      <el-button size="small" icon="el-icon-plus" v-auth="'/plus/insti/insti/add'" type="primary" @click="addClick">添加发票</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="bill_id" label="ID" width="50"></el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
               <div v-if="scope.row.type == 1">企业单位</div>
               <div v-if="scope.row.type == 2">个人/非企业单位</div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="抬头名称"></el-table-column>
            <el-table-column prop="tax_numb" label="纳税人识别号"></el-table-column>

            <el-table-column prop="address" label="地址"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="bank" label="开户银行（选填）"></el-table-column>
            <el-table-column prop="account" label="银行账户"></el-table-column>
            <el-table-column prop="email" label="电子邮箱"></el-table-column>
            <el-table-column prop="user.nickName" label="申请人">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.user.nickName }}({{ scope.row.user.mobile }})
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="price" label="开票金额"></el-table-column>

            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                  <span v-if="scope.row.status== 1">未审核</span>
                  <span v-if="scope.row.status== 2">已通过</span>
                  <span v-if="scope.row.status== 3">未通过</span>
                  <span v-if="scope.row.status== 4">请重新审核</span>
              </template>

            </el-table-column>
       
            <el-table-column prop="reject_val" label="不通过原因"></el-table-column>

            <!-- <el-table-column prop="image" label="电子发票">
              <template slot-scope="scope">
                <img v-img-url="hasImages(scope.row.tax_url)" alt="" width="60px" />
              </template>
            </el-table-column> -->



            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button v-if="scope.row.status == 1 || scope.row.status == 4" @click="passClick(scope.row)" type="text" size="small">通过</el-button><br />
                <el-button v-if="scope.row.status == 1 || scope.row.status == 4" @click="nopassClick(scope.row)" type="text" size="small">不通过</el-button><br />

               
                <el-button @click="deleteClick(scope.row)" v-auth="'/plus/insti/insti/del'" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Edit :open_add="open_edit" :bill_id="bill_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  </div>
</template>

<script>
  import BillApi from '@/api/bill.js';
  import Edit from './part/edit.vue';
  import qs from 'qs';
  export default {
    components: {
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          status:-1,
        },

        open_add:false,
        open_edit:false,
        bill_id:""
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      hasImages(e) {
        if (e) {
          return e;
        } else {
          return '';
        }
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    reast(){
      this.formInline= {
          search:"",
          status:-1,
        }

      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        BillApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.bill_id = row.bill_id;
        this.open_edit = true
      },
      jumpClick(e){
        this.$router.push({
          path: '/plus/insti/comment',
          query: {
            name: e.name
          }
        });
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            BillApi.del(
              {
                bill_id: row.bill_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      async passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        bill_id:item.bill_id,
        status:2,
        reject_val:""
      }
      BillApi.pass(Params, true)
                          .then(data => {
                            if(data.code == 1){
                              self.$message({
                                  type: 'success',
                                  message: '审核成功'
                              });
                                self.getTableList();
                                return false;
                            }
                          })
                          .catch(error => {});
      

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原因', '请输入不通过的原因');

      var Params = {
        bill_id:item.bill_id,
        status:3,
        reject_val:reject_val
      }
      console.log(reject_val)
      if(reject_val == undefined){
        console.log("取消")
      }else{
          if(reject_val.length > 0){
            BillApi.nopass(Params, true)
                      .then(data => {
                        if(data.code == 1){
                          self.$message({
                              type: 'success',
                              message: '审核成功'
                          });
                            self.getTableList();
                            return false;
                        }
                      })
                      .catch(error => {});
          }else{
            this.$message({
              type: 'error',
              message: '请输入不通过的原因',
            });
          }
  
      }
     
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/plus.bill.Bill/export?' + qs.stringify(this.formInline);
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/bill/index/index.vue